<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav *ngIf="!readonly" class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="formInvalid" type="submit" title="Guardar" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <nav *ngIf="readonly && !dialogMode" class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid"  [ngClass]="{ 'container-no-overflow': dialogMode }">
        <h4>{{ title }} Empresa Deshidratadora</h4><!--@adua incluirlo cuando se desarrolle la pantalla-->
        <!--<h4> Datos Empresa Deshidratadora</h4>-->

        <div class="card card-accent-success animated fadeIn">
            <a class="card-header-a" (click)="isCollapsed = !isCollapsed"
               [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                <div class="card-header-buscador">
                    <i class="fa fa-filter"></i> Datos Básicos
                    <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                    <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                </div>
            </a>
            <div class="card-body">

                <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                    <div class="row">
                        <div class="form-group col-xl-2 col-md-4">
                            <label class="col-form-label required-field" for="inpCodigo">Número de Registro</label>
                            <input [readonly]="readonly" formControlName="NumeroRegistro" name="NumeroRegistro" maxlength="50" title="" class="form-control" id="inpDescripcion"
                                   type="text" value="" [ngClass]="displayFieldCss('NumeroRegistro')">

                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NumeroRegistro','required')">
                                El Campo Número de Registro es obligatorio
                            </div>

                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NumeroRegistro','NumeroRegistro_duplicated')">
                                El Número de Registro de la Empresa ya existe en la base de datos
                            </div>
                        </div>

                        <div class="form-group col-xl-4 col-md-4">
                            <label class="col-form-label required-field" for="inpCodigo">Nombre de Empresa  </label>
                            <input [readonly]="readonly" formControlName="NombreIndustria" name="NombreIndustria" maxlength="255" title="" class="form-control" id="inpDescripcion" type="text" value="" [ngClass]="displayFieldCss('NombreIndustria')">

                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NombreIndustria','required')">
                                El Campo Nombre de Empresa es obligatorio
                            </div>

                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NombreIndustria','NombreIndustria_duplicated')">
                                El Nombre de Empresa  ya existe en la base de datos
                            </div>
                        </div>

                        <div class="form-group col-xl-4 col-md-4">
                            <label class="col-form-label required-field" for="inpCodigo">Dirección</label>
                            <input [readonly]="readonly" formControlName="Direccion" name="Direccion" maxlength="1000" title="" class="form-control" id="inpDescripcion" type="text" value="" [ngClass]="displayFieldCss('Direccion')">

                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Direccion','required')">
                                El Campo Dirección es obligatorio
                            </div>
                        </div>
                    </div>
                    <div class="row">

                        <div class="form-group col-xl-2 col-md-4">
                            <label class="col-form-label" for="inpProvincia">Provincia</label>

                            <ng-select loadingText="Cargando..."
                                       [items]="listProvincias"
                                       placeholder="-- Seleccione una Provincia --"
                                       [readonly]="!listProvincias || listProvincias.length === 0 || readonly"
                                       [loading]="!listProvincias || listProvincias.length === 0"
                                       bindLabel="Descripcion"
                                       bindValue="Id"
                                       formControlName="IdProvincia"
                                       notFoundText="Provincia no encontrada"
                                       (change)="onSelectProvincia()"
                                       clearAllText="Eliminar selección">
                            </ng-select>
                        </div>

                        <div class="form-group col-xl-4 col-md-4">
                            <label class="col-form-label" for="inpMunicipio">Municipio</label>

                            <ng-select loadingText="Cargando..."
                                       [items]="listMunicipios"
                                       placeholder="-- Seleccione un Municipio --"
                                       [loading]="(!listMunicipios || listMunicipios.length === 0) && (form.value.IdProvincia > 0)"
                                       bindLabel="Descripcion"
                                       bindValue="Id"
                                       formControlName="IdMunicipio"
                                       notFoundText="Municipio no encontrado"
                                       [readonly]="readonly"
                                       clearAllText="Eliminar selección">
                            </ng-select>
                        </div>

                        <div class="form-group col-xl-2 col-md-2">
                            <label class="col-form-label" for="inpActivo">Activo</label>
                            <p-toggleButton class="form-control-togglebutton"
                                            formControlName="Activo"
                                            [disabled]="readonly"
                                            name="Activo"
                                            onLabel="Sí"
                                            offLabel="NO"
                                            onIcon="pi pi-check"
                                            offIcon="pi pi-times">
                            </p-toggleButton>
                        </div>

                        <div *ngIf="empresaDeshidratadora?.Desautorizada" class="form-group col-xl-2 col-md-2">
                            <label class="col-form-label" for="inpDesautorizada">Desautorizada</label>
                            <p-toggleButton class="form-control-togglebutton"
                                            formControlName="Desautorizada"
                                            [disabled]="readonly"
                                            name="Desautorizada"
                                            onLabel="Sí"
                                            offLabel="NO"
                                            onIcon="pi pi-check"
                                            offIcon="pi pi-times">
                            </p-toggleButton>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="empresaDeshidratadora?.Desautorizada" class="card card-accent-success animated fadeIn">
            <a class="card-header-a" (click)="isCollapsedDesautorizados = !isCollapsedDesautorizados"
               [attr.aria-expanded]="!isCollapsedDesautorizados" aria-controls="collapseDesautorizados">
                <div class="card-header-buscador">
                    <i class="fa fa-filter"></i> Desautorizada en las siguientes campañas
                    <i *ngIf="isCollapsedDesautorizados" class="fa fa-caret-down float-right"></i>
                    <i *ngIf="!isCollapsedDesautorizados" class="fa fa-caret-up float-right"></i>
                </div>
            </a>
            <div class="card-body">

                <div class="collapse group-filtros" id="collapseDesautorizados" [ngbCollapse]="isCollapsedDesautorizados">

                    <div class="row">
                        <div *ngFor="let campania of empresaDeshidratadora?.CampaniasDesautorizado" class="nota-info">
                            <label class="col-form-label">{{ campania?.Descripcion }} el {{ campania.Fecha | date:'dd/MM/yyyy HH:mm' }}</label>
                        </div>
                    </div>

                </div>
            </div>
        </div>  

    </div>
</form>
